import { NotaDebitoDetalle } from "./nota-debito-detalle";
import { Cobro } from "./cobro";
import { Caja } from "./caja";
import { Venta } from "./venta";

export class NotaDebito {
    public constructor(
        public id: String = "",
        public tipo: String = "",
        public tipo_comprobante_id: number = 0,
        public serie: String = "",
        public punto_emision: String = "",
        public secuencial: String = "",
        public numero_documento: String = "",
        public is_secuencial_manual: boolean = false,
        public fecha_emision: any = "",
        public numero_autorizacion: String = "",
        public subtotal_iva0: number = 0,
        public subtotal_iva12: number = 0,
        public subtotal: number = 0,
        public iva: number = 0,
        public total: number = 0,
        public tipo_pago: String = "CO",
        public abonado:number = 0,
        public observacion: String = "",
        public json_string: any = {},
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public documento_id: String = "",
        public caja_id: String = "",
        public status: String = "",
        public usuario_id: String = "",

        public detalle: Array<NotaDebitoDetalle> = [],
        public cobros: Array<Cobro> = [],
        public tipocomprobante: any = {},
        public estadobitacora: any = {},
        public caja: Caja = new Caja(),
        public venta: Venta = new Venta(),

    ){
        //
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/nota-debito.ts